export default "/images/vendor/flag-icons/flags/4x3/al.svg?3868e719427cb24633921d8d2e505b48";